
$(function () {
    //アコーディオン（よくある質問）
    $('.question--list--item--question').on('click', function () {
      var findElm = $(this).next(".question--list--item--answer");
      $(findElm).slideToggle();
      if ($(this).hasClass('close')) {
        $(this).removeClass('close');
      } else {
        $(this).addClass('close');
      }
    });

    // ポップアップ
    $(window).scroll(function() {
      const scrollY = $(window).scrollTop();
      const popupTrigger = 1040;
      // 一定距離スクロールしたらポップアップを表示
      if (scrollY > popupTrigger) {
        $('#popup').addClass('fadeIn');
        $('#popup').css('pointer-events', 'auto');
      } else {
        $('#popup').removeClass('fadeIn');
        $('#popup').css('pointer-events', 'none');
      }
    });
    $('.fv--popup--close').on('click', function () {
      $('#popup').css('display', 'none');
    });


    // アニメーション
    $(window).on('load', function(){
      loadAnime();
      });
      $(window).scroll(function (){
        scrollAnime();
      });

      function loadAnime(){
          // フェードイン
          $('.fadeInTrigger').each(function(){
            var elemPos = $(this).offset().top-50;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll >= elemPos - windowHeight){
            $(this).addClass('fadeIn');
            }else{
            $(this).removeClass('fadeIn');
            }
            });
            // フェードイン(下から)
        $('.fadeInUpTrigger').each(function(){
          var elemPos = $(this).offset().top-50;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll >= elemPos - windowHeight){
          $(this).addClass('fadeInUp');
          }else{
          $(this).removeClass('fadeInUp');
          }
          });
      // フェードイン（左から）
        $('.fadeInLeftTrigger').each(function(){
          var elemPos = $(this).offset().top-50;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll >= elemPos - windowHeight){
          $(this).addClass('fadeInLeft');
          }else{
          $(this).removeClass('fadeInLeft');
          }
          });
      // フェードイン（右から）
        $('.fadeInRightTrigger').each(function(){
          var elemPos = $(this).offset().top-50;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll >= elemPos - windowHeight){
          $(this).addClass('fadeInRight');
          }else{
          $(this).removeClass('fadeInRight');
          }
          });
      }

      function scrollAnime(){
             // フェードイン
             $('.fadeInTrigger').each(function(){
              var elemPos = $(this).offset().top-50;
              var scroll = $(window).scrollTop();
              var windowHeight = $(window).height();
              if (scroll >= elemPos - windowHeight){
              $(this).addClass('fadeIn');
              }else{
              $(this).removeClass('fadeIn');
              }
              });

      // フェードイン(下から)
        $('.fadeInUpTrigger').each(function(){
          var elemPos = $(this).offset().top-50;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll >= elemPos - windowHeight){
          $(this).addClass('fadeInUp');
          }else{
          $(this).removeClass('fadeInUp');
          }
          });

      // フェードイン（左から）
        $('.fadeInLeftTrigger').each(function(){
          var elemPos = $(this).offset().top-50;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll >= elemPos - windowHeight){
          $(this).addClass('fadeInLeft');
          }else{
          $(this).removeClass('fadeInLeft');
          }
          });
      // フェードイン（右から）
        $('.fadeInRightTrigger').each(function(){
          var elemPos = $(this).offset().top-50;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll >= elemPos - windowHeight){
          $(this).addClass('fadeInRight');
          }else{
          $(this).removeClass('fadeInRight');
          }
          });
      }
  });
